import plaidBankIcon from "../../assets/plaidBankIcon.svg";
import { Button } from "../button/index.jsx";
import React from "react";
import { formatter } from "../../utils/formatCurrency";
import { StyledBankLogo } from "./styled.jsx"
import PropTypes from "prop-types";
import { Trans, useTranslation } from 'react-i18next';

export const CreditBodyContent = ({setViewTC = null, obvInfo = {}, handleConfirm = null}) => {
  const { amount, accountSubType } = obvInfo;
  const { t } = useTranslation();

  const txTypeName = t('credit.confirm.title');
  const txConfirm = t('obv.button.confirm');
  const txAmount = `${formatter(amount)}`;

  return (
      <>
        <div className='topSection'>
          <StyledBankLogo className='plaidBankIcon' src={plaidBankIcon}
               alt='plaidBankIcon'/>
          <div className='textContent'>
            <h1>You&apos;re ready to complete your {txTypeName}</h1>
            <p>
              <b>{obvInfo.merchantName} will transfer {txAmount} to:</b>
            </p>
            <p>{obvInfo.institutionName} {accountSubType.charAt(0).toUpperCase()
            + accountSubType.slice(1)} account **&nbsp;{obvInfo.accountMask}</p>
          </div>
        </div>
        <div className='bottomSection'>
          <div className='tcContainer' role="button"
               tabIndex={0} onClick={() => setViewTC(true)} onKeyDown={() => setViewTC(true)}>
            <h6>
              <Trans
                i18nKey="common.terms.agreement"
                components={{
                  bold: <b />
                }}
              />
            </h6>
          </div>
          <Button type='default'
                  onClick={() => handleConfirm(obvInfo.clientReferenceId)}>
            {txConfirm} {txAmount} {txTypeName}
          </Button>
        </div>
      </>
  );
}

CreditBodyContent.propTypes = {
  setViewTC: PropTypes.func,
  obvInfo: PropTypes.object,
  handleConfirm: PropTypes.func,
};